<template>
    <div>
        <i
            :style="{ color: 'green' }"
            v-if="value == 0"
            class="fas fa-battery-three-quarters fa-2x"
        ></i>
        <i
            :style="{ color: 'red' }"
            v-if="value == 1"
            class="fas fa-battery-empty fa-2x"
        ></i>
    </div>
</template>
<script>
export default {
    props: ['value']
};
</script>
